import axios from 'axios'
const API_URL = "https://blooggerr.onrender.com/blogs/"
// const API_URL = "http://localhost:8080/"

function postComment(blogId, commentData, _headers){
    console.log("POST COMMENT")
    return axios.post(`${API_URL}comment/${blogId}`, commentData, {headers: _headers})
}

function getComments(blogId){
    console.log("GET COMMENT")
    return axios.get(`${API_URL}comment/${blogId}`)
}

function updateComment(commentData, blogId, _headers){
    return axios.patch(`${API_URL}comment/${blogId}`, commentData, {headers: _headers})
}

function deleteComment(commentId, blogId, _headers){
    return axios.delete(`${API_URL}comment/${blogId}/${commentId}`, {headers: _headers})
}

export {postComment, getComments, updateComment, deleteComment}